import { connect } from 'react-redux'
import { userMyAgent } from 'Modules/user/data/actions'

import UpdateMyAgent from './UpdateMyAgent'

const stateToProps = (state) => ({
  lastSearchObj: state.location.lastSearchObj,
  userIsAuthentificated: state.userData.userIsAuthentificated,
})
const actions = {
  getMyAgent: userMyAgent,
}

export default connect(stateToProps, actions)(UpdateMyAgent)
